import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { lifecycle, pure, compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import { withRouter } from 'react-router'

import {
  mount,
  unmount
} from './actions'

import {
  projectRoleSelector,
  isProjectLoadedSelector,
} from './selectors'

const mapStateToProps = (state) => {
  return {
    isLoaded: isProjectLoadedSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    mount: (projectId) => dispatch(mount(projectId)),
    unmount: () => dispatch(unmount())
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withLifecycle = lifecycle({
  componentWillMount() {
    const {
      match,
      mount,
    } = this.props
    this.props.mount(match.params.id)
  },
  componentWillUnmount() {
    this.props.unmount()
  }
})

export default compose(
  withRouter,
  withConnect,
  withLifecycle,
)
